import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Lock } from 'lucide-react';
import { Product } from '../../data/products';
import { ProductPlaceholder } from '../ProductPlaceholder';
import { isRestrictedProduct } from '../../data/inventory';
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  const isRestricted = isRestrictedProduct(product);
  return <Link to={`/inventory/${product.category}/${product.slug}`} className="group bg-white border border-steel-200 rounded-sm overflow-hidden hover:border-cg-orange-600 transition-all duration-300 flex flex-col h-full" data-id="element-227">
      {/* Image — fixed aspect ratio */}
      <div className="relative aspect-[4/3] bg-slate-100 overflow-hidden flex-shrink-0" data-id="element-228">
        <ProductPlaceholder aspectRatio="4/3" className="w-full h-full text-steel-300" data-id="element-229" />

        {isRestricted && <div className="absolute top-2.5 left-2.5 sm:top-3 sm:left-3" data-id="element-230">
            <span className="bg-red-100 text-red-800 text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 sm:py-1 rounded-sm border border-red-200 flex items-center gap-1" data-id="element-231">
              <Lock className="w-3 h-3" data-id="element-232" /> Restricted
            </span>
          </div>}
      </div>

      {/* Content — flex-grow for equal height cards */}
      <div className="p-4 sm:p-5 flex flex-col flex-grow min-h-0" data-id="element-233">
        <h3 className="text-sm sm:text-base font-bold text-navy-900 mb-1 group-hover:text-cg-orange-600 transition-colors line-clamp-2 leading-snug" data-id="element-234">
          {product.name}
        </h3>
        <p className="text-xs sm:text-sm text-steel-600 mb-3 sm:mb-4 line-clamp-2 flex-grow" data-id="element-235">
          {product.shortDescription}
        </p>

        <div className="mt-auto flex items-center justify-between pt-3 border-t border-steel-100" data-id="element-236">
          <span className="text-xs font-bold uppercase tracking-wider text-cg-orange-600 flex items-center gap-1 group-hover:gap-2 transition-all" data-id="element-237">
            View Item <ArrowRight className="w-3 h-3" data-id="element-238" />
          </span>
        </div>
      </div>
    </Link>;
}